import { useEffect } from "react";

import AssociatesCalendar from "./AssociatesCalendar";


const openPopup = (id) => {
  document.getElementById(id).style.display = "block";
};

/*
 * Closes the specified popup.
 */
const closePopup = (id) => {
  document.getElementById(id).style.display = "none";
};

function Associates() {
  useEffect(() => {
    document.title = "Associates";
  });
  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Associates</h1>
          </div>
          <div class="flex-vert" style={{ marginTop: "-10px" }}>
            <div class="sub-hrule"></div>
            <div class="sub-head" style={{ marginBottom: '30px' }}>
            </div>
            <p class="paragraph-center sub">
              Associates are valued members of the Rice faculty, staff, and 
              community who offer resources and support for Wiessmen. Some 
              associates are Rice alumni, some are current or retired Rice 
              professors, and some are community members who want to get 
              involved! While each associate may engage in different ways or 
              bring different gifts to the table, they are all united to 
              support current Wiessmen.
            </p>
            <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
              <h3 className="h3">For Associates</h3>
              <div className="sub-hrule"></div>
            </div>
            <p class="paragraph-center sub">
              There is no one “right” way to be an associate. Some examples of 
              how associates have been involved at Wiess include joining students
              at lunch in commons, promoting career networking events, organizing
              game nights, leading cooking tutorials in our second-floor kitchen,
              cheering on the students at intramural games, attending Associate's
              nights, and on and on. Just show up!! Do you want to host an O-Week
              group? If so, you can be an extra resource for a small group of new 
              students throughout the school year. If you would like any 
              additional information, you can reach out to our college coordinator,
              Jenny Toups, at {" "}
              <a
                href="mailto: jt87@rice.edu"
                class="link"
              >
                jt87@rice.edu
              </a>, or our EVP, Jaden, at {" "}
              <a
                href="mailto: wiesscollegeevp@gmail.com"
                class="link"
              >
                wiesscollegeevp@gmail.com
              </a>.
            </p>
            <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
              <h3 className="h3">How to Join</h3>
              <div className="sub-hrule"></div>
            </div>
            <p class="paragraph-center sub">
              If you are interested in becoming a Wiess associate or would like to 
              learn more about the program, please email our college coordinator, 
              Jenny Toups, at {" "}
              <a
                href="mailto: jt87@rice.edu"
                class="link"
              >
                jt87@rice.edu
              </a>. She is happy to answer any questions you might have!  If you have any 
              initial questions, feel free to look over the {" "}
              <a
                href="https://drive.google.com/file/d/16E9SMGhFJE8KKDkpXsFS8lKBAxtFVDhd/view?usp=sharing"
                class="link"
              >
                Wiess Associates Guide
              </a>.
            </p>
            <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
              <h3 className="h3">For Students</h3>
              <div className="sub-hrule"></div>
            </div>
            <p class="paragraph-center sub">
              All of our associates have been selected by our Associates Committee with the
               sole purpose of mentoring and supporting our students. If you see what looks
                like a Wiess community member chatting at an associate's barbecue or hosting
                a study break in Wiess Commons, you are encouraged to introduce yourself! 
                All of our associates would love to get to know you. If you are a Wiessman
                who is interested in speaking to one of the associates listed below, 
                feel free to use their listed emails to reach out. If you are a current Wiess
                student who wants to serve on our Associates Committee, reach out to Caitlin
                to get connected. 
            </p>
            <div>
                <AssociatesCalendar> </AssociatesCalendar>
              </div>
          </div>
        </div>
        <div class="people-section">
          <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <h3 className="h3">Our Associates</h3>
              <div className="sub-hrule"></div>
          </div>
          <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <h3 className="h3">Community Associates</h3>
          </div>
          <div class="people-grid">
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Stehanie Anderson and George Fotinos.JPG"
                  height="200"
                  alt="Associate Anderson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Stephanie Anderson & George Fotinos
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("arnold-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Michelle and Frank Arnold.jpg"
                  height="200"
                  alt="Associate Arnold"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("arnold-popup")}
                  style={{ cursor: "pointer" }}
                >
                  J. Frank &amp; Michelle Arnold
                </h4>
              </div>
              <p class="position">
                VP of Administration, Houston Dynamo; Professional Home
                Organizer
              </p>
              <div id="arnold-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseArnold"
                    class="close-button"
                    onClick={() => closePopup("arnold-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      J. Frank &amp; Michelle Arnold
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Frank and Michelle Arnold met at Wiess during sophomore
                      year and have been inseparable since. Michelle majored in
                      Biological Sciences and was active in the college as a
                      Social VP and Diversity Coordinator for O-Week. She
                      currently owns her own professional organizing business in
                      Houston, Good Clean Function, and is an active crossfitter
                      and gardener. Frank majored in Sports Management and
                      enjoyed playing lacrosse, being the External VP, and a
                      fellow for O-Week. He has served in multiple roles for the
                      Houston Dynamo since 2007 and is currently their VP of
                      Administration. Frank enjoys biking, playing D&D, and
                      camping. They have two dogs, Doug and Lily, and two
                      chinchillas, Flipper and Dipper. They both enjoy hiking at
                      Texas State Parks and finding new Houston restaurants to
                      enjoy.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Caroline Arzoo.png"
                  height="200"
                  alt="Associate Arzoo"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Caroline Arzoo
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/AJ Beard Web.jpg"
                  height="200"
                  alt="Associate Beard"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  AJ Beard
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images/general/wiessshield.svg"
                  height="200"
                  alt="Associate Bracht"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Chuck Bracht
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Tyler de Salazar Picture.jpg"
                  height="200"
                  alt="Associate Salazar"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Tyler de Salazar
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Sarah Edmonson.jpeg"
                  height="200"
                  alt="Associate Edmonson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Sarah Edmonson
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Emma Ferguson.jpg"
                  height="200"
                  alt="Associate Ferguson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Emma Ferguson
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Carol Germano.jpeg"
                  height="200"
                  alt="Associate Germano"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Carol Germano
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Josh Hale.png"
                  height="200"
                  alt="Associate Hale"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Josh Hale
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Alan Hsieh.jpeg"
                  height="200"
                  alt="Associate Hsieh"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Alan Hsieh
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/David Leal.webp"
                  height="200"
                  alt="Associate Leal"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  David Leal
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("lee-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Eric Lee Web.jpg"
                  height="200"
                  alt="Associate Lee"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("lee-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Eric Lee
                </h4>
              </div>
              <p class="position">
                Assistant Professor, Baylor College of Medicine
              </p>
              <div id="lee-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="LeeButton"
                    class="close-button"
                    onClick={() => closePopup("lee-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Eric & Cristine Lee</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Eric (BA Biochemistry/Psychology, Jones ’00) from Port
                      Lavaca, TX, went to medical school at UTSW in Dallas,
                      followed by family medicine residency in Houston. He has
                      worked for the Baylor College of Medicine since. He is
                      involved in medical student education (director/adviser in
                      the learning communities program, facilitator for the MS1
                      doctoring course, admissions committee work, mentor for
                      students interested in family medicine, etc.).
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/John and Kelly Ma.jpg"
                  height="200"
                  alt="Associate Ma"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  John & Melly Ma
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Lily Ma and Chad Zhao.jpg"
                  height="200"
                  alt="Associate LilyMa"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Lily Ma & Chad Zhao
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("mack-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Brandon Mack.jpg"
                  height="200"
                  alt="Associate Mack"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("mack-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Brandon Mack
                </h4>
              </div>
              <p class="position">Associate Director of Admission</p>
              <div id="mack-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseMack"
                    class="close-button"
                    onClick={() => closePopup("mack-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Brandon Mack</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Brandon Mack is an Associate Director of Admission &
                      Coordinator of Transfer Admission at Rice University. Mack
                      is also a community activist and sociologist dedicated to
                      issues related to the intersections of race, gender, and
                      sexual orientation. He has conducted research on
                      effemiphobia, the negativity related to effeminate gay
                      men. His work has been featured in a GLAAD Media Award
                      winning article and he has presented his work at national
                      conferences such as the National LGBTQ Task Force:
                      Creating Change and NBJC's Out on the Hill. He is a lead
                      organizer with Black Lives Matter: Houston. Co-Chapter
                      Director of New Leaders Council - Houston. Screening
                      Committee and Education and Advocacy Chair of the Houston
                      GLBT Political Caucus.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Tania Min and family.png"
                  height="200"
                  alt="Associate Min"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Tania Min
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Sue Murphey.jpeg"
                  height="200"
                  alt="Associate Murphey"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Susan Murphey
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("jmyers-popup")}
              >
                <img
                  src="/images/associates/myers.png"
                  height="200"
                  alt="Associate Myers"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("jmyers-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jeff Myers
                </h4>
              </div>
              <p class="position">
                General Manager,
                Raven Aerospace Technology
              </p>
              <div id="jmyers-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseMyers"
                    class="close-button"
                    onClick={() => closePopup("jmyers-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Jeff Myers
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Jeff is an aerospace engineer and
                      co-owner of a small consulting firm. He is happy to talk
                      with people about career paths and options.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Terry and Ellen Phillips.jpg"
                  height="200"
                  alt="Associate Phillips"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Terry & Ellen Phillips
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Grant Belton &AJ Price.jpg"
                  height="200"
                  alt="Associate Price"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  AJ Price
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Elaine Palinkas Sanches family.jpg"
                  height="200"
                  alt="Associate Sanches"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Marsal Sanches
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Jim Sheng.jpg"
                  height="200"
                  alt="Associate Sheng"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jim Sheng
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("sneller-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Sneller_Chris.JPG"
                  height="200"
                  alt="Associate Sneller"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("sneller-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Chris Sneller
                </h4>
              </div>
              <p class="position">
                Director of Innovation; Bridges International
              </p>
              <div id="sneller-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseSneller"
                    class="close-button"
                    onClick={() => closePopup("sneller-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Chris Sneller</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      I've been an Associate at Wiess for 14 years but I had a
                      3-year pause while I did a PhD in London. My area of
                      research is historical theology (my dissertation focused
                      on Christianity in 20th century China). I have six kids,
                      ranging from 20 to 8 years old. In my free time I enjoy
                      doing CrossFit, watching Arsenal Football Club, and
                      mountain biking. At Rice I like hanging out at Wiess and
                      teaching an English class in the Office of International
                      Students and Scholars.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Andrew Swick.jpg"
                  height="200"
                  alt="Associate Swick"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Andrew & Catherine Swick
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Nathanael Tan.jpg"
                  height="200"
                  alt="Associate Tan"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Nathanael Tan
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("terrazas-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Renata Ramos and Lenin Terrazas.jpg"
                  height="200"
                  alt="Associate Terrazas"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("terrazas-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Lenin Terrazas
                </h4>
              </div>
              <p class="position">
                School of Engineering & Consultant
              </p>
              <div id="terrazas-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseTerrazas"
                    class="close-button"
                    onClick={() => closePopup("terrazas-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Lenin Terrazas
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Lenin has a background in engineering and change
                      management. Wiess was his first family
                      home. He was an Wiess RA from 2011 to 2018 and lived on the
                      3rd floor. The closets are still mainly goldenrod! TFW!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Dhruv & Andrea Venkatraman.jpg"
                  height="200"
                  alt="Associate Venkatraman"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Dhruv Venkatraman
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/John Wilson.jpg"
                  height="200"
                  alt="Associate Wilson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  John Wilson
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Bob Zhang.jpg"
                  height="200"
                  alt="Associate Zhang"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Bob Zhang
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Jared Zimmerman.png"
                  height="200"
                  alt="Associate Zimmerman"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jared Zimmerman
                </h4>
              </div>
            </div>
          </div>
          <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <h3 className="h3">Faculty Associates</h3>
          </div>
          <div class="people-grid">
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Elias Bongmba.png"
                  height="200"
                  alt="Associate Bongmba"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Elias K. Bongmba
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Alexander Byrd.webp"
                  height="200"
                  alt="Associate Byrd"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Alexander Byrd
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Mahmoud Amin El-Gamal.webp"
                  height="200"
                  alt="Associate El-Gamal"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Mahmoud El-Gamal
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Maryam Emami.webp"
                  height="200"
                  alt="Associate Emami"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Maryam Emami
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Todd W Ferguson.jpg"
                  height="200"
                  alt="Associate Ferguson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Todd Ferguson
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("shimizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Sayuri Guthrie Shimizu.png"
                  height="200"
                  alt="Associate Shimizu"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("shimizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Sayuri Guthrie Shimizu
                </h4>
              </div>
              <p class="position"> Dunlevie Family Professor of History</p>
              <div id="shimizu-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseShimizu"
                    class="close-button"
                    onClick={() => closePopup("shimizu-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Sayuri Guthrie Shimizu
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      I am a dual citizen of the US and Japan but in truth I
                      consider myself a "citizen of the world," (having grown up
                      in five different countries)." I teach and research on the
                      history of US-East Asian relations, the Asia-Pacific World
                      and global history of sports. I am a former recipient of
                      Fulbright (2), MacArthur, Mellon Foundation, SSRC, and
                      Woodrow Wilson Center fellowships. I am a licensed (in
                      Japan) chef and love to cook for my family, friends and,
                      most importantly, my students at Rice. I welcome dinner
                      guests from Wiess!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Mikki Hebl.webp"
                  height="200"
                  alt="Associate Hebl"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Mikki Hebl
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("hutchinson-popup")}
              >
                <img
                  src="/images2025-26/new-associates/John and Paula Hutchinson.jpg"
                  height="200"
                  alt="Associate Hutchinson"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("hutchinson-popup")}
                  style={{ cursor: "pointer" }}
                >
                  John &amp; Paula Hutchinson
                </h4>
              </div>
              <p class="position">
                {" "}
                Professor of Chemistry; Adjunct Professor; Former Wiess
                Magisters
              </p>
              <div id="hutchinson-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="HutchinsonClose"
                    class="close-button"
                    onClick={() => closePopup("hutchinson-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      John &amp; Paula Hutchinson
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      As magisters of Wiess for 7 years, we know what a unique
                      and special environment the college provides, and how
                      important faculty associates are in being a resource to
                      the students. Everyone knows John as a chemistry professor
                      and former Dean of Undergraduates, and Paula is a former
                      journalist, attorney and teacher. We are avid cyclists and
                      hikers, and if we're not around Rice, we're up at our
                      cabin in Colorado. We look forward to having a great
                      relationship with our O-Week students and being a resource
                      to all!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Nets Katz.webp"
                  height="200"
                  alt="Associate Katz"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Nets Katz
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Jung Youn Lee.jpeg"
                  height="200"
                  alt="Associate Lee"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jung Youn Lee
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Arlei Lopes da Silva.jpeg"
                  height="200"
                  alt="Associate Lopes da Silva"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Arlei Lopes da Silva
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("rmyers-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Risa Myers.jpg"
                  height="200"
                  alt="Associate Myers"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("rmyers-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Risa Myers
                </h4>
              </div>
              <p class="position">
                Assistant Teaching Professor, Rice University
              </p>
              <div id="rmyers-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseMyers"
                    class="close-button"
                    onClick={() => closePopup("rmyers-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Risa Myers
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Risa is an Assistant Teaching Professor in the Computer
                      Science department where she teaches students about
                      databases and data science. She also is a Data Scientist
                      with the Children's Environmental Health Initiative at the
                      University of Notre Dame. She completed a "late" life PhD
                      (at Rice) after a career in software engineering and
                      project management.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Doug Natelson.jpg"
                  height="200"
                  alt="Associate Natelson"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Douglas Natelson
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Betul Orcan- Ekmekci.webp"
                  height="200"
                  alt="Associate Orcan"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Betul Orcan
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("pai-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Mallesh Pai.webp"
                  height="200"
                  alt="Associate Pai"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("pai-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Mallesh Pai
                </h4>
              </div>
              <p class="position">Department of Economics, Rice University</p>
              <div id="pai-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="ClosePai"
                    class="close-button"
                    onClick={() => closePopup("pai-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Mallesh Pai</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      I'm an Associate Prof and also the incoming Director of
                      Undergrad Studies in the econ department. My primary
                      research interests are in microeconomic theory
                      (specifically game theory/ mechanism design). In
                      particular, I'm interested in stuff at the intersection of
                      computer science and economic theory: both understanding
                      the modern web/ social media/ sharing economy via the
                      prism of game theory, and more recently, contributing to
                      the theory of machine learning (which has some overlap
                      with game theory)! Feel free to reach out if you'd like to
                      chat about economics@rice, my research, or more broadly
                      e.g. opportunities in econ, and in tech for econ-y types.
                      I'm generally down for coffee... Also glad to chat over
                      lunch in Wiess (whenever they let us back in!).. I look
                      like the pic except I currently have a beard and
                      (significantly) less hair than when this was taken.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Scott Powers.jpg"
                  height="200"
                  alt="Associate Powers"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Scott Powers
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("ramos-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Renata Ramos and Lenin Terrazas.jpg"
                  height="200"
                  alt="Associate Ramos"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("ramos-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Renata Ramos
                </h4>
              </div>
              <p class="position">
                Associate Teaching Professor of Bioengineering and 
                Associate Dean for Academic Affairs
              </p>
              <div id="ramos-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseRamos"
                    class="close-button"
                    onClick={() => closePopup("ramos-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Renata Ramos
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Renata is the Associate Dean for Academic Affairs for 
                      the School of Engineering and an Associate Teaching Professor 
                      in Bioengineering. She began her career at Rice in 2008. 
                      She was a Wiess RA from 2011 to 2018 and lived on the
                      3rd floor. The closets are still mainly goldenrod! TFW!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("h-santos-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Helade Scutti Santos Web.jpg"
                  height="200"
                  alt="Associate HSantos"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("h-santos-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Hélade Santos
                </h4>
              </div>
              <p class="position">
                Director of Language Instruction and Portuguese Lecturer at the
                Center for Languages and Intercultural Communication
              </p>
              <div id="h-santos-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseHSantos"
                    class="close-button"
                    onClick={() => closePopup("h-santos-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Hélade Santos
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      My aria-label is Hélade. I teach Portuguese at Rice and I
                      am also the Director of the Center for Languages and
                      Intercultural Communication. I am from Brazil and I came
                      to the US to do my PhD in Spanish and Portuguese
                      Linguistics. I absolutely love teaching at Rice, mainly
                      because of the students I have had and the relationships I
                      have developed with each and everyone of them. Teaching
                      languages and thinking about different opportunities for
                      Rice students to experience other languages and cultures,
                      including study abroad, make me truly excited about my
                      work. When I am not working I love to do simple things: to
                      be home with my family, watch good movies, go for long
                      walks, practice yoga and work on my garden.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Andrew and Laura Schaefer (1).jpg"
                  height="200"
                  alt="Associate ASchaefer"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Andrew & Laura Schaefer
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Rebecca and Christian Schreib.jpg"
                  height="200"
                  alt="Associate RSchreib"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Rebecca & Christian Schreib
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("wagner-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Dan Wagner Web.jpg"
                  height="200"
                  alt="Associate Wagner"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("wagner-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Dan Wagner
                </h4>
              </div>
              <p class="position">Associate Professor in BioSciences</p>
              <div id="wagner-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseWagner"
                    class="close-button"
                    onClick={() => closePopup("wagner-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Dan Wagner</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      In my day job I'm a developmental biologist. I study the
                      genetic regulation of development in zebrafish and snails.
                      I'm a strong supporter of undergrad research and other
                      avenues of engagement with science. I've been the faculty
                      sponsor of Catalyst (http://ricecatalyst.org/) since it's
                      creation. If you are interested in any of these things
                      drop me a line.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("xiao-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Han Xiao.jpg"
                  height="200"
                  alt="Associate Xiao"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("xiao-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Han Xiao
                </h4>
              </div>
              <p class="position">
                Assistant Professor of Chemistry, Biosciences, and
                Bioengineering
              </p>
              <div id="xiao-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseXiao"
                    class="close-button"
                    onClick={() => closePopup("xiao-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Han Xiao</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      I am currently an Assistant Professor of Chemistry,
                      Biosciences, and Bioengineering at Rice University. I
                      obtained my undergraduate degree from the University of
                      Science and Technology of China and a PhD degree in
                      chemical biology at the Scripps Research Institute. My
                      research focuses on the development of various chemical
                      tools that allow us to precisely probe and manipulate
                      biological systems. My program has a strong translational
                      focus, seeking to initiate new clinical opportunities, and
                      contribute to advances in chemical biology, glycobiology,
                      and cancer immunology.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Carrissa Zimmerman.webp"
                  height="200"
                  alt="Associate CZimmerman"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Carissa Zimmerman
                </h4>
              </div>
            </div>
          </div>
          <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <h3 className="h3">Honorary Associates</h3>
          </div>
          <div class="people-grid">
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Neal Lane.png"
                  height="200"
                  alt="Associate Lane"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Neal Lane
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Dale Spence.webp"
                  height="200"
                  alt="Associate Spence"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Dale Spence
                </h4>
              </div>
            </div>
          </div>
          <div class="sub-head" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <h3 className="h3">University Associates</h3>
          </div>
          <div class="people-grid">
          <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Jennifer Allen.jpg"
                  height="200"
                  alt="Associate Allen"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jennifer Allen
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Terri Arellano.jpg"
                  height="200"
                  alt="Associate Arellano"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Teresa (Terri) Arellano
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Derek Bell Photo.jpg"
                  height="200"
                  alt="Associate Bell"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Derek Bell
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Grant Belton &AJ Price.jpg"
                  height="200"
                  alt="Associate Belton"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Grant Belton
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("brown-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Danika Brown.jpeg"
                  height="200"
                  alt="Associate Brown"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("brown-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Danika Brown
                </h4>
              </div>
              <p class="position">Director, Center for Civic Leadership</p>
              <div id="brown-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label=" CloseBrown"
                    class="close-button"
                    onClick={() => closePopup("brown-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Danika Brown</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Originally from Nevada, Danika did her undergraduate
                      degree in English and Philosophy at University of Nevada,
                      Reno, her MA in English at Arizona State, and her PhD in
                      Rhetoric and the Teaching of English at the University of
                      Arizona. She was an associate professor of English and
                      founding Director of the Office of Undergraduate Research
                      and Service Learning at the University of Texas, Pan
                      American (now RGV) before coming to Rice to serve as a
                      Director in the Center for Civic Leadership where she
                      oversees the Certificate in Civic Leadership programming
                      and fellowship advising. She is an avid dog lover,
                      puzzler, and bird watcher. She is especially happy to
                      support students seeking civic and community engaged
                      opportunities. As a first-generation low income college
                      student, she is also a resource for navigating the
                      resources and challenges for students with similar
                      backgrounds. She hopes to be a strong ally for all
                      students at Rice.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("chatfield-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Carlyn-Chatfield-2023.jpg"
                  height="200"
                  alt="Associate Chatfield"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("chatfield-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Carlyn Foshee Chatfield
                </h4>
              </div>
              <p class="position">
                Retired Staff (Enrollment, OIT, Computer Science Departments)
              </p>
              <div id="chatfield-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseChatfield"
                    class="close-button"
                    onClick={() => closePopup("chatfield-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Carlyn Foshee Chatfield
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Carlyn became a Wiess College Associate around
                      2004, when one of Carlyn's Rice OIT colleagues invited her
                      to apply. She hosts an O-Week group each year and
                      developed a customized board game - "The Game" - to help
                      new students learn their way around Rice. Like Sorry,
                      players attempt to cross the campus while evading
                      opponents. Like Clue, there are secret passages; ours are
                      called Art & Archi Detours. Carlyn also hosts cooking
                      classes and other study breaks at Wiess.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("corcuera-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Maria Corcuera.jpg"
                  height="200"
                  alt="Associate Corcuera"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("corcuera-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Maria Corcuera
                </h4>
              </div>
              <p class="position">
                International Advisor at OISS, Rice University
              </p>
              <div id="corcuera-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseCorcuera"
                    class="close-button"
                    onClick={() => closePopup("corcuera-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Maria Corcuera
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Maria Corcuera is an International Adviser for Exchange
                      Scholars at OISS. She oversees the immigration paperwork
                      process for Exchange Scholars with Jenny Brydon. Maria was
                      born and raised in Mexico City, and has a Law degree from
                      UNAM. She loves ballet, music, theater and gardening.
                      Maria moved to Houston in 1999 with her husband Manolo and
                      their two daughters, Ana and Sofia. She lives in Sugar
                      Land and is proud of being a Wiess Associate.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Sunita Dharani Headshot.jpeg"
                  height="200"
                  alt="Associate Dharani"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Sunita Dharani
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("galindo-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Andrea Escamilla-Galinda.jpg"
                  height="200"
                  alt="Associate Galindo"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("galindo-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Andrea Escamilla-Galindo
                </h4>
              </div>
              <p class="position">Post Award Administrator, ECE Department</p>
              <div id="galindo-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseGalindo"
                    class="close-button"
                    onClick={() => closePopup("galindo-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Andrea Escamilla-Galindo</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Administrator by day, mariachi by night! Well, and mom all
                      the time ;) I have a B.S and M.S. in biology, but my
                      passion is in the performing arts. I have been singing
                      with the Mariachi Luna Llena since it foundation, in 2013.
                      I have been a Wiess Associate for about 6 years, and won
                      Associate of the Year twice in a row. I like to engage
                      physically and intellectually, so I enjoy physical
                      activities, sports, crafting, and puzzles. I love
                      traveling, cooking, yoga, gardening and more.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Nick Espinosa and Carissa Zimmerman.jpeg"
                  height="200"
                  alt="Associate Espinosa"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Nick Espinosa
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Kerby Goff.jpg"
                  height="200"
                  alt="Associate Goff"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Kerby Goff
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("hudlow-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Doward & Christie Hudlow.jpg"
                  height="200"
                  alt="Associate Hudlow"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("hudlow-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Doward Hudlow Jr.
                </h4>
              </div>
              <p class="position">
                Director of Development Research and Analysis, Development and
                Alumni Relations
              </p>
              <div id="hudlow-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseHudlow"
                    class="close-button"
                    onClick={() => closePopup("hudlow-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>
                      Doward Hudlow Jr.
                    </h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Doward is a Wiessmen from the
                      class of 2001. Doward grew up in Houston near campus. 
                      As a Wiessman I enjoyed, well,
                      everything . . . Tabletop, Cabinet, Court, Powderpuff,
                      intramural sports, Acabowl, Backabowl . . . you aria-label
                      it. I was lucky enough to be an RA at Wiess from 2002 to
                      2008, which was an amazing experience. Now I live near
                      campus with my wife and our two sons, Riley (13) and Chase (11). We
                      enjoy having an O-Week group to our house every year.
                      Doward would be happy to meet anyone interested or even
                      just curious about what Development and Alumni Relations
                      are about (fundraising and alumni engagement). Doward’s an
                      avid cyclist who’s always happy to discuss riding or, even
                      better, go for ride. My boys are fun gamer/sports
                      enthusiasts so hopefully you’ll get a chance to meet them
                      too!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Paul Janish.png"
                  height="200"
                  alt="Associate Janish"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Paul Janish
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Ewart Jones.jpg"
                  height="200"
                  alt="Associate Jones"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Ewart Jones
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Jenny judge profile pic rice.jpg"
                  height="200"
                  alt="Associate Judge"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Jenny Judge
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("martinez-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Maria Martinez.jpg"
                  height="200"
                  alt="Associate Martinez"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("martinez-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Maria Martinez
                </h4>
              </div>
              <p class="position">
                {" "}
                Program and Events Coordinator, Department of Visual and
                Dramatic Arts
              </p>
              <div id="martinez-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseMartinez"
                    class="close-button"
                    onClick={() => closePopup("martinez-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Maria Martinez</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Maria Martinez received her B.A. in Advertising and Public
                      Relations from City University New York, graduating cum
                      laude. After moving back to Houston, Texas in 2008, she
                      became an entrepreneur opening a retail business and later
                      creating an organic beauty line consisting of lip colors,
                      balms, and perfumes. She has worked for internationally
                      recognizable brands such as Converse in their Public
                      Relations department, and local Houston festivals Day for
                      Night as the Media Buyer, Free Press Summer Festival as
                      the Market Vendor Manager, and with ongoing Houston
                      Vintage as a co-organizer and producer. Maria enjoys
                      organizing and promoting events, engaging and bringing
                      communities together, and reviving the art of socializing.
                      In her spare time she works with friends on music related
                      projects and takes pleasure in books, films, theatre
                      productions, traveling, playing drums, DIY projects, and
                      all things vintage.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Lena McCarver.jpeg"
                  height="200"
                  alt="Associate McCarver"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Lena McCarver
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/LaTia McPherson-Sadler Web.jpg"
                  height="200"
                  alt="Associate McPherson-Sadler"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  LaTia McPherson-Sadler
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/David Medina.png"
                  height="200"
                  alt="Associate Medina"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  David Medina
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Lach and Kari Mullen.jpg"
                  height="200"
                  alt="Associate LMullen"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Lach & Kari Mullen
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Elaine Palinkas Sanches family.jpg"
                  height="200"
                  alt="Associate Sanches"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Elaine Palinkas Sanches
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Paula Platt.jpg"
                  height="200"
                  alt="Associate Platt"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Paula Platt
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Larissa A Valenzuela Buelna.png"
                  height="200"
                  alt="Associate Valenzuela"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Larissa Romero Valenzuela
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("a-santos-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Anne Santos web.jpg"
                  height="200"
                  alt="Associate ASantos"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("a-santos-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Anne K. T. Santos
                </h4>
              </div>
              <p class="position">
                HR Administrator/EA to the Dean - Susanne M. Glasscock School of
                Continuing Studies
              </p>
              <div id="a-santos-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseASantos"
                    class="close-button"
                    onClick={() => closePopup("a-santos-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Anne K. T. Santos</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Hi TFW! I love being a Wiess Associate and look forward
                      to many more years getting to know students! I work in the
                      Susanne M. Glasscock School of Continuing Studies
                      supporting the Dean and the School with administrative
                      functions. Fun fact: some Wiess alums have worked for us
                      over the summer summer months and beyond! I'm a
                      Jill-of-all-trades with a background in Hospitality,
                      International Commerce, and FinTech. I graduated from
                      Boston University (Go Terriers!) and found my happy niche
                      in higher education at Rice University (Go Owls!). During
                      my free time, I enjoy traveling for standup paddleboard
                      races, building LEGOs, floating (OneWheel) Hermann Park,
                      and teaching my pup (Louie) new tricks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Christina Triantaphyllis.png"
                  height="200"
                  alt="Associate Triantaphyllis"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Christina Triantaphyllis
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Ettore Uilvim ORIG.jpg"
                  height="200"
                  alt="Associate Ulivim"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Ettore Ulivim
                </h4>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                onClick={() => openPopup("ustundag-popup")}
              >
                <img
                  src="/images2025-26/new-associates/Efe Ustundag.jpeg"
                  height="200"
                  alt="Associate Ustundag"
                />
                <div class="overlay">
                  <div class="overlay-text">
                    <h4>Learn More</h4>
                  </div>
                </div>
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  onClick={() => openPopup("ustundag-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Efe Ustundag
                </h4>
              </div>
              <p class="position">Head Men’s Tennis Coach</p>
              <div id="ustundag-popup" class="popup-base">
                <div class="popup-content">
                  <button
                    aria-label="CloseUstundag"
                    class="close-button"
                    onClick={() => closePopup("ustundag-popup")}
                  >
                    &times;
                  </button>
                  <div class="popup-text-holder">
                    <h4 style={{ textAlign: "center" }}>Efe Ustundag</h4>
                    <p style={{ fontSize: "16px", textAlign: "left" }}>
                      Hi There Wiess- I am the Head Men’s Tennis Coach and a
                      Rice Alum (Class of ‘99). After graduating from Rice, I
                      returned to my home country Turkey and played on the
                      professional tennis tour for about 2.5 years. I was lucky
                      to return to Rice as an assistant coach in 2004 and was
                      even more fortunate to become the head coach in 2012. I
                      have been an associate at Wiess since 2005. I am married
                      to a rock star associate professor of neurology at UT
                      medical school and we have an 8 year old daughter. TFW!!!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="person-card">
              <div
                class="prof-pic-with-overlay"
                // onClick={() => openPopup("arbizu-popup")}
              >
                <img
                  src="/images2025-26/new-associates/yahaira verdejo.jpeg"
                  height="200"
                  alt="Associate Verdejo"
                />
              </div>
              <div class="div-block-15">
                <h4
                  class="h4"
                  // onClick={() => openPopup("arbizu-popup")}
                  style={{ cursor: "pointer" }}
                >
                  Yahaira Verdejo
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Associates;
